export default "__VITE_ASSET__4aaaef20__"